
export default function Tools() {
  const toolCategories = [
    {
      category: 'Design Tools',
      tools: ['Figma', 'Adobe XD', 'Photoshop', 'Illustrator'],
      icon: 'ri-pencil-ruler-2-line',
      color: 'blue'
    },
    {
      category: 'Development',
      tools: ['HTML', 'CSS', 'JavaScript', 'Odoo'],
      icon: 'ri-code-s-slash-line',
      color: 'teal'
    },
    {
      category: 'Analytics & BI',
      tools: ['Power BI', 'Data Visualization', 'User Analytics'],
      icon: 'ri-bar-chart-box-line',
      color: 'blue'
    },
    {
      category: 'AI & Automation',
      tools: ['AI UX Tools', 'Content Generation', 'Workflow Optimization'],
      icon: 'ri-robot-line',
      color: 'teal'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Tools & Technologies</h2>
          <div className="w-20 h-1 bg-blue-600 mx-auto"></div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {toolCategories.map((category, index) => (
            <div key={index} className="bg-gray-50 p-6 rounded-2xl hover:shadow-xl transition-all transform hover:-translate-y-2">
              <div className={`w-16 h-16 ${category.color === 'blue' ? 'bg-blue-100' : 'bg-teal-100'} rounded-xl flex items-center justify-center mb-4`}>
                <i className={`${category.icon} ${category.color === 'blue' ? 'text-blue-600' : 'text-teal-600'} text-3xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">{category.category}</h3>
              <div className="space-y-2">
                {category.tools.map((tool, idx) => (
                  <div key={idx} className="flex items-center gap-2">
                    <div className={`w-2 h-2 rounded-full ${category.color === 'blue' ? 'bg-blue-600' : 'bg-teal-600'}`}></div>
                    <span className="text-gray-700">{tool}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
